import { Theme } from "@material-ui/core";
const styles = (theme: Theme) =>
  ({
    forbiddenPage: {
      textAlign: "center",
      "& h1": {
        marginTop: 24,
      },
      "& p": {
        marginBottom: 24,
      },
    },
  } as any);

export default styles;
